import { getDictFirstKey } from 'pxc-editor-core/helpers/common';

export const toProjFileContent = (codeData) => {
  const res = {
    contents: codeData.text,
    type: innerOuterBarcodeTypeMap(codeData.codeType, 'bwipBcid', 'outerEnumVal'),
    options: {}
  };
  const optName = innerOuterBarcodeTypeMap(codeData.codeType, 'bwipBcid', 'projFileOptField');
  res.options[optName] = {};
  for (const o_n in codeData) {
    const outON = innerOuterBarcodeOptionsNamesMap(o_n);
    if (outON !== undefined) {
      const origVal = codeData[o_n];
      const outOV = innerOuterBarcodeOptionsValuesMap(origVal);
      res.options[optName][outON] = typeof outOV === 'undefined' ? origVal : outOV;
    }
  }
  return res;
};

export const fromProjFileContent = (codeData) => {
  const res = {
    text: codeData?.contents || '',
    codeType: innerOuterBarcodeTypeMap(codeData.type, 'outerEnumVal', 'bwipBcid')
  };
  const optName = getDictFirstKey(codeData?.options);
  for (const o_n in codeData.options[optName]) {
    const outON = innerOuterBarcodeOptionsNamesMap(null, o_n);
    if (outON !== undefined) {
      const origVal = codeData.options[optName][o_n];
      const outOV = innerOuterBarcodeOptionsValuesMap(null, origVal);
      res[outON] = typeof outOV === 'undefined' ? origVal : outOV;
    }
  }

  return res;
};

const innerOuterBarcodeTypeMap = (val, valField, resField) => {
  const res = innerOuterBarcodeTypeMapData.find(row => row[valField] === val);
  return res ? res[resField] : null;
};

const innerOuterBarcodeOptionsNamesMap = (bwipBcid, projFileOptField) => {
  if (bwipBcid) {
    return innerOuterBarcodeOptionsNamesMapData.find(row => row.bwipBcid === bwipBcid)?.projFileOptField;
  }
  else if (projFileOptField) {
    return innerOuterBarcodeOptionsNamesMapData.find(row => row.projFileOptField === projFileOptField)?.bwipBcid;
  }
};

const innerOuterBarcodeOptionsValuesMap = (bwipBcid, projFileOptField) => {
  if (bwipBcid) {
    return innerOuterBarcodeOptionsValuesMapData.find(row => row.bwipBcid === bwipBcid)?.projFileOptField;
  }
  else if (projFileOptField) {
    return innerOuterBarcodeOptionsValuesMapData.find(row => row.projFileOptField === projFileOptField)?.bwipBcid;
  }
};

const innerOuterBarcodeTypeMapData = [
  { bwipBcid: 'code39', outerEnumVal: 'CODE_39', projFileOptField: 'code39' },
  { bwipBcid: 'code128', outerEnumVal: 'CODE_128', projFileOptField: 'code128' },
  { bwipBcid: 'interleaved2of5', outerEnumVal: 'ITF_25', projFileOptField: 'itf25' },
  { bwipBcid: 'ean8', outerEnumVal: 'EAN_8', projFileOptField: 'ean8' },
  { bwipBcid: 'ean13', outerEnumVal: 'EAN_13', projFileOptField: 'ean13' },
  { bwipBcid: 'upca', outerEnumVal: 'UPC_A', projFileOptField: 'upc_a' },
  { bwipBcid: 'upce', outerEnumVal: 'UPC_E', projFileOptField: 'upc_e' },
  { bwipBcid: 'qrcode', outerEnumVal: 'QR_CODE', projFileOptField: 'qr_code' },
  { bwipBcid: 'datamatrix', outerEnumVal: 'DATA_MATRIX', projFileOptField: 'data_matrix' }
];

const innerOuterBarcodeOptionsNamesMapData = [
  { bwipBcid: 'barratio', projFileOptField: 'bar_ratio' },
  { bwipBcid: 'includetext', projFileOptField: 'include_text' },
  { bwipBcid: 'includecheck', projFileOptField: 'include_check' },
  { bwipBcid: 'includecheckintext', projFileOptField: 'include_check_in_text' },
  { bwipBcid: 'textxalign', projFileOptField: 'horizontal_alignment' },
  { bwipBcid: 'textyalign', projFileOptField: 'vertical_alignment' },
  { bwipBcid: 'guardwhitespace', projFileOptField: 'guard_whitespace' },
  { bwipBcid: 'hidestars', projFileOptField: 'hide_stars' },
  { bwipBcid: 'eclevel', projFileOptField: 'ecc_level' },
];

const innerOuterBarcodeOptionsValuesMapData = [
  { bwipBcid: 'offleft', projFileOptField: 'OFF_LEFT' },
  { bwipBcid: 'left', projFileOptField: 'LEFT' },
  { bwipBcid: 'center', projFileOptField: 'CENTER' },
  { bwipBcid: 'right', projFileOptField: 'RIGHT' },
  { bwipBcid: 'offright', projFileOptField: 'OFF_RIGHT' },
  { bwipBcid: 'justify', projFileOptField: 'JUSTIFY' },
  { bwipBcid: 'above', projFileOptField: 'ABOVE' },
  { bwipBcid: 'below', projFileOptField: 'BELOW' },
  { bwipBcid: 'L', projFileOptField: 'LOW' },
  { bwipBcid: 'M', projFileOptField: 'MEDIUM' },
  { bwipBcid: 'Q', projFileOptField: 'QUARTILE' },
  { bwipBcid: 'H', projFileOptField: 'HIGH' },
];